export const SignInWIthGoogleSvg = () => (
  <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <mask id="mask0_426_11376" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="16">
      <path
        d="M14.8256 6.60475H7.67442V9.56987H11.7907C11.407 11.4536 9.80233 12.535 7.67442 12.535C5.16279 12.535 3.13953 10.5117 3.13953 8.0001C3.13953 5.48847 5.16279 3.46522 7.67442 3.46522C8.75581 3.46522 9.73256 3.84894 10.5 4.47685L12.7326 2.24429C11.3721 1.05824 9.62791 0.325684 7.67442 0.325684C3.4186 0.325684 0 3.74429 0 8.0001C0 12.2559 3.4186 15.6745 7.67442 15.6745C11.5116 15.6745 15 12.8838 15 8.0001C15 7.54661 14.9302 7.05824 14.8256 6.60475Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0_426_11376)">
      <path d="M-0.697754 12.5351V3.46533L5.23248 8.00022L-0.697754 12.5351Z" fill="#FBBC05" />
    </g>
    <mask id="mask1_426_11376" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="16">
      <path
        d="M14.8256 6.60475H7.67442V9.56987H11.7907C11.407 11.4536 9.80233 12.535 7.67442 12.535C5.16279 12.535 3.13953 10.5117 3.13953 8.0001C3.13953 5.48847 5.16279 3.46522 7.67442 3.46522C8.75581 3.46522 9.73256 3.84894 10.5 4.47685L12.7326 2.24429C11.3721 1.05824 9.62791 0.325684 7.67442 0.325684C3.4186 0.325684 0 3.74429 0 8.0001C0 12.2559 3.4186 15.6745 7.67442 15.6745C11.5116 15.6745 15 12.8838 15 8.0001C15 7.54661 14.9302 7.05824 14.8256 6.60475Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask1_426_11376)">
      <path
        d="M-0.697754 3.46514L5.23248 8.00002L7.67434 5.87212L16.0464 4.51165V-0.37207H-0.697754V3.46514Z"
        fill="#EA4335"
      />
    </g>
    <mask id="mask2_426_11376" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="16">
      <path
        d="M14.8256 6.60475H7.67442V9.56987H11.7907C11.407 11.4536 9.80233 12.535 7.67442 12.535C5.16279 12.535 3.13953 10.5117 3.13953 8.0001C3.13953 5.48847 5.16279 3.46522 7.67442 3.46522C8.75581 3.46522 9.73256 3.84894 10.5 4.47685L12.7326 2.24429C11.3721 1.05824 9.62791 0.325684 7.67442 0.325684C3.4186 0.325684 0 3.74429 0 8.0001C0 12.2559 3.4186 15.6745 7.67442 15.6745C11.5116 15.6745 15 12.8838 15 8.0001C15 7.54661 14.9302 7.05824 14.8256 6.60475Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask2_426_11376)">
      <path
        d="M-0.697754 12.5349L9.76736 4.51165L12.5232 4.86049L16.0464 -0.37207V16.3721H-0.697754V12.5349Z"
        fill="#34A853"
      />
    </g>
    <mask id="mask3_426_11376" maskUnits="userSpaceOnUse" x="0" y="0" width="15" height="16">
      <path
        d="M14.8256 6.60475H7.67442V9.56987H11.7907C11.407 11.4536 9.80233 12.535 7.67442 12.535C5.16279 12.535 3.13953 10.5117 3.13953 8.0001C3.13953 5.48847 5.16279 3.46522 7.67442 3.46522C8.75581 3.46522 9.73256 3.84894 10.5 4.47685L12.7326 2.24429C11.3721 1.05824 9.62791 0.325684 7.67442 0.325684C3.4186 0.325684 0 3.74429 0 8.0001C0 12.2559 3.4186 15.6745 7.67442 15.6745C11.5116 15.6745 15 12.8838 15 8.0001C15 7.54661 14.9302 7.05824 14.8256 6.60475Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask3_426_11376)">
      <path
        d="M16.0467 16.3723L5.23275 8.00022L3.8374 6.9537L16.0467 3.46533V16.3723Z"
        fill="#4285F4"
      />
    </g>
  </svg>
);

export const SignInWithMicrosoftSvg = () => (
  <svg width="16" height="17" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0.839111H9.50377V10.3429H0V0.839111Z" fill="#F25022" />
    <path d="M10.4963 0.839111H20.0001V10.3429H10.4963V0.839111Z" fill="#7FBA00" />
    <path d="M0 11.3353H9.50377V20.8391H0V11.3353Z" fill="#00A4EF" />
    <path d="M10.4963 11.3353H20.0001V20.8391H10.4963V11.3353Z" fill="#FFB900" />
  </svg>
);
